<template>
	<div>
		<div style="text-align: left;">
			<el-button size="small" type="primary" icon="el-icon-plus" @click="addCom">新增</el-button>
		</div>
		<div class="comStyle">
			<el-table
			  :data="tableData"
			  @selection-change="handleSelectionChange"
			  :row-class-name="tableRowClassName"
			  size="mini"
			  border
			  stripe
			  style="width: 50%; margin-top: 10px">
			  <el-table-column
			          type="selection"
			          width="55">
			  </el-table-column>
			  <el-table-column
				prop="id"
				label="编号" width="55">
			  </el-table-column>
			  <el-table-column
				prop="slaveName"
				label="设备名称" width="80">
			  </el-table-column>
			  <el-table-column
				prop="adrr"
				label="设备地址" width="80">
			  </el-table-column>
			  <el-table-column
				prop="startres"
				label="开始寄存器" >
			  </el-table-column>
			  <el-table-column
				prop="munber"
				label="读寄存器个数" width="120">
			  </el-table-column>
			  <el-table-column
				prop="cycle"
				label="采集周期(s)" width="85">
			  </el-table-column>
			 
			</el-table>
			</div>
			<div style="text-align: left;">
				<el-button size="small" type="danger" icon="el-icon-check" @click="updateCom"
				:disabled="multipleSelection.length==0">编辑</el-button>
				<el-button size="small" type="danger" icon="el-icon-minus" @click="deleteCom"
				:disabled="multipleSelection.length==0">删除</el-button>
			</div>
			<el-dialog
				  :title="namelg"
				  :visible.sync="dialogVisible"
				  
				  width="30%">
			 <el-form :rules="rules"
				  ref='updatePos' label-position="right" label-width="110px"
				  :model="updatePos" class="comDia" size="mini">
				  <span>
				  <el-form-item label="编号" >
				  <el-input class="updatePosInput" size="small" v-model="updatePos.id" 
				  disabled=false ></el-input>
				  </el-form-item>
				  <el-form-item label="设备名称" prop="slaveName">
				  <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.slaveName"></el-input>
				  </el-form-item>
				  <el-form-item label="设备地址" prop="adrr">
				  <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.adrr"></el-input>
				  </el-form-item>
				  </span>
				  <el-form-item label="开始寄存器" prop="startres">
				  <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.startres"></el-input>
				  </el-form-item>

				  <el-form-item label="读寄存器个数" prop="munber">
				  <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.munber"></el-input>
				  </el-form-item>

				  <el-form-item label="采集周期(s)" prop="cycle">
				  <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.cycle"></el-input>
				  </el-form-item>
				  <el-form-item>
				  <el-button size="small" @click="dialogVisible = false">取 消</el-button>
				  <el-button size="small" type="primary" @click="doUpdate(updatePos)">确 定</el-button>
				  </el-form-item>
			  </el-form>
			  
		  </el-dialog>
	</div>
</template>

<script>
	export default {
		name: "Lufft",	
		data() {
		  return {
			namelg:"更新从机配置",
		    tableData: [],
			dialogVisible: false,
			showf:true,
			multipleSelection: [],
			updatePos: {
				id:'',
				slaveName:'',
			    adrr:'',
			    startres:'',
				munber: '',
				cycle: '',
				
			},
			rules:{
				slaveName: [
					{ required: true,message: '设备名称不能为空！', trigger: 'blur' }
				],
				adrr: [
					{ required: true,message: '设备地址不能为空！', trigger: 'blur' }
				],
				startres:  [
					{ required: true, message: '开始寄存器不能为空！',trigger: 'blur' }
				],
				munber:  [
					{ required: true, message: '读寄存器个数不能为空！',trigger: 'blur' }
				],
				cycle:  [
					{ required: true,message: '采集周期不能为空！', trigger: 'blur' }
				],
				
			}
		  };
		},
		mounted() {
			this.initLoad();
		},
		methods: {
			tableRowClassName({row, rowIndex}) {
				if ((rowIndex%2) == 1) {
				  return 'success-row';
				} 
				return '';
			  },
			addCom(){
				this.namelg='保存从机配置'
				this.updatePos.id='';
				this.updatePos.slaveName='';
				this.updatePos.adrr='';
				this.updatePos.startres='';
				this.updatePos.munber='';
				this.updatePos.cycle='';
				
				this.dialogVisible=true;
			},
			doUpdate(){
				this.$refs.updatePos.validate((valid) => {
					if (valid) {
						if(this.updatePos.id==''){
							this.$confirm('此操作新建一条记录', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
							    this.postRequest("/com/ma/lufft",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消保存'
							    });
							});
						}else{
							this.$confirm('此操作修改ID=【' + this.updatePos.id + '】的记录?', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
							    this.postRequest("/com/ma/lufft",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消修改'
							    });
							});
						}
					} else {
						console.log('请输入所有字段！');
						return false;
					}
				})
				
				
			},
			updateCom(){
				if(this.multipleSelection.length!=1){
					this.$message({
					    type: 'warning',
					    message: '请选择单条数据编辑！'
					});
				}else{
					this.namelg='更新从机配置'
					this.multipleSelection.forEach(item => {
						this.updatePos.id=item.id;
						this.updatePos.slaveName=item.slaveName;
						this.updatePos.adrr=item.adrr;
						this.updatePos.munber=item.munber;
						this.updatePos.startres=item.startres;
						this.updatePos.cycle=item.cycle;
						
						
					});
					this.dialogVisible=true;
					
					
				}
			},
			deleteCom(){this.$confirm('此操作将永久删除【' + this.multipleSelection.length + '】条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '?';
                    this.multipleSelection.forEach(item => {
                        ids += 'ids=' + item.id + '&';
                    })
                    this.deleteRequest("/com/ma/lufft" + ids).then(resp => {
                        if (resp) {
                            this.initLoad();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			initLoad(){
				this.getRequest("/com/ma/lufft").then(resp => {
				    //this.loading = false;
				    if (resp) {
				        this.tableData = resp;
				    }
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  arraySpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (rowIndex % 2 === 0) {
		      if (columnIndex === 0) {
		        return [1, 2];
		      } else if (columnIndex === 1) {
		        return [0, 0];
		      }
		    }
		  },
				
		  objectSpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (columnIndex === 0) {
		      if (rowIndex % 2 === 0) {
		        return {
		          rowspan: 2,
		          colspan: 1
		        };
		      } else {
		        return {
		          rowspan: 0,
		          colspan: 0
		        };
		      }
		    }
		  }
		}
	}
</script>

<style>
	.el-table .success-row {
	    background: #f0f9eb;
	  }
	.comStyle{
		margin-bottom: 8px
	}
	.updatePosInput {
	    width: 200px;
	    margin-left: 10px;
	}
	.comDia{
		/* text-align: left; 
		margin-left: 8px; */
		margin-bottom: 8px;
		padding: 15px 35px 15px 35px;
		
	}
	
</style>

